import * as z from 'zod'

export const schema = z.object({
  name: z.string().min(1, { message: 'Name is required' }),
})

export type CreateAdditionalCostTypeFormValues = z.infer<typeof schema>
